import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Padangusthasana = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Padangusthasana.title1"), context: t("Padangusthasana.context1") },
      { title: t("Padangusthasana.title2"), context: t("Padangusthasana.context2") },
      { title: t("Padangusthasana.title3"), context: t("Padangusthasana.context3") },
      { title: t("Padangusthasana.title4"), context: t("Padangusthasana.context4") },
      { title: t("Padangusthasana.title5"), context: t("Padangusthasana.context5") },
      { title: t("Padangusthasana.title6"), context: t("Padangusthasana.context6") },
      { title: t("Padangusthasana.title7"), context: t("Padangusthasana.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Padangusthasana.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/Padangusthasana+YOGA.mp4'}
                title="Description"
                context={t("Padangusthasana.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Padangusthasana
